import {useState} from 'react'
import {useDispatch} from 'react-redux'
import {useOnboardingPipelines} from '../hooks'

import {Link,useHistory} from 'react-router-dom'

import {envAwarePost} from '../../../util/util'

import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'

import {
	setPipelineAssignmentsEditor,
	createOnboardingPipeline,
	deleteOnboardingPipeline,
	setPipelineAssignModal,
} from '../slice'

const Pipeline = ({pipeline})=>{
	const dispatch = useDispatch()
	const openAssignModal = ()=>{
		dispatch(setPipelineAssignModal({
			show:true,
			id:pipeline.id
		}))
	}
	const openAssignmentsEditor = ()=>{
		dispatch(setPipelineAssignmentsEditor({
			show:true,
			id:pipeline.id
		}))
	}
	const handleDelete = ()=>{
		if(!window.confirm('Are you sure you want to delete this automation?')) return 

		dispatch(deleteOnboardingPipeline(pipeline.id))
	}
	return (
		<div className="d-flex justify-content-between p-3 mt-2 border rounded align-items-start">
			<div>
				{pipeline.name || 'Untitled Automation'}
				<small className="d-block">
					Length: {pipeline.length}
				</small>
				<div className="d-flex align-items-center">
					<small className="d-block mr-1">
						Assignments:
					</small>
					<div className="d-flex align-items-center">
						<button 
							onClick={openAssignmentsEditor}
							style={{
								fontSize:'12px',
								border:'none',
								background:'none',
								color:'blue',
								padding:'0'
							}}
						>
							Existing
						</button>
						<span className="d-inline-block mx-1">|</span>
						<button 
							onClick={openAssignModal}
							style={{
								fontSize:'12px',
								border:'none',
								background:'none',
								color:'blue',
								padding:'0'
							}}
						>
							Add
						</button>
					</div>
				</div>
			</div>
			<div>
				<Button 
					className="mr-1"
					onClick={handleDelete}
					variant="outline-danger"
					size="sm"
				>
					<i className="fa fa-trash"/>
				</Button>
				<Button 
					variant="outline-primary"
					size="sm"
					as={Link} 
					to={`/onboarding-pipeline-editor?id=${pipeline.id}`}
				>
					<i className="fa fa-edit"/>
				</Button>
			</div>
		</div>
	)
}

export default function OnboardingPipelines(){
	const {status,pipelines} = useOnboardingPipelines()
	const history = useHistory()
	const [isCreating,setIsCreating] = useState(false)
	const dispatch = useDispatch()
	const handleCreatePipeline = ()=>{
		setIsCreating(true)
		dispatch(createOnboardingPipeline({}))
		.then(res=>{
			setIsCreating(false)
			const id = res.payload.data.onboarding_pipeline.id
			history.push(`/onboarding-pipeline-editor?id=${id}`)
		})
	}

	return (
		<div>
			<Button 
				variant="outline-success"
				onClick={handleCreatePipeline}
				disabled={isCreating}
			>
				Create Automation {isCreating&&<Spinner animation="border" size="sm"/>}
			</Button>
			<Alert variant="info" className="mt-2 text-dark">
				<small>
					<i className="fa fa-info-circle mr-1"/>
					Automations streamline interaction with potential clients. Create multi-day automations to send messages, assign program samples, and more. Prospects can be automatically or manually assigned to these automations. This ensures timely and consistent communication, helping trainers efficiently grow their business by engaging potential clients with the right information at the right time without additional effort.
				</small>
			</Alert>
			<div>
				{pipelines.map(pipeline=><Pipeline pipeline={pipeline}/>)}
			</div>
		</div>
	)
}